import { Animated, Easing, Text, View } from "react-native";
import { useEffect, useRef } from "react";

export function LiveIndicator({ label = "LIVE" }: { label?: string }) {
  const pulse = useRef(new Animated.Value(1)).current;
  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(pulse, { toValue: 0.3, duration: 1000, easing: Easing.inOut(Easing.ease), useNativeDriver: true }),
        Animated.timing(pulse, { toValue: 1, duration: 1000, easing: Easing.inOut(Easing.ease), useNativeDriver: true }),
      ])
    );
    loop.start();
    return () => loop.stop();
  }, [pulse]);
  return (
    <View className="flex-row items-center gap-1.5">
      <Animated.View className="h-[5px] w-[5px] rounded-full bg-success-bright" style={{ opacity: pulse }} />
      <Text className="text-[10px] font-bold uppercase tracking-[0.16em] text-success-bright">{label}</Text>
    </View>
  );
}
